import { styled } from '../../../Utilities';
import { ShimmerElementsGroupBase } from './ShimmerElementsGroup.base';
import { getStyles } from './ShimmerElementsGroup.styles';
export var ShimmerElementsGroup = styled(ShimmerElementsGroupBase, getStyles, undefined, {
  scope: 'ShimmerElementsGroup'
});